import { ClickAwayListener, Grow, Paper, Popper, PopperPlacementType } from "@mui/material";
import React, { MouseEventHandler, ReactElement, RefObject } from "react";
import styles from "./DropDown.module.css";

interface DropDownProps {
	children: ReactElement;
	className?: string | null;
	disablePortal?: boolean;
	onClose?: ((event: MouseEvent | TouchEvent, ref: RefObject<HTMLElement>) => void) | null;
	open?: boolean;
	paperStyle?: React.CSSProperties;
	position?: PopperPlacementType;
	onMouseEnter?: MouseEventHandler<HTMLDivElement>;
	onMouseLeave?: MouseEventHandler<HTMLDivElement>;
}

const DropDown = React.forwardRef<HTMLElement, DropDownProps>(
	(
		{
			children,
			className = null,
			disablePortal = false,
			onClose = null,
			open = false,
			paperStyle = undefined,
			position = "bottom-start",
			onMouseEnter,
			onMouseLeave,
		},
		ref
	) => (
		<Popper
			transition
			anchorEl={(ref as React.RefObject<HTMLElement>)?.current}
			className={`${styles.dropDown__menus} ${className}`}
			disablePortal={!!disablePortal}
			open={open}
			placement={position}
		>
			{({ TransitionProps, placement }) => (
				<Grow
					{...TransitionProps}
					className={
						placement === position ? styles["dropDown__menus--shown"] : styles["dropDown__menus--hidden"]
					}
				>
					<Paper
						square={false}
						style={paperStyle}
						variant="elevation"
						onMouseEnter={onMouseEnter}
						onMouseLeave={onMouseLeave}
					>
						<ClickAwayListener
							onClickAway={(e) => {
								if (onClose && typeof onClose === "function") {
									onClose(e, ref as React.RefObject<HTMLElement>);
								}
							}}
						>
							{children}
						</ClickAwayListener>
					</Paper>
				</Grow>
			)}
		</Popper>
	)
);
export default DropDown;
